// src/context/LanguageContext.js
import React, { createContext, useState, useEffect, useCallback } from "react";

export const LanguageContext = createContext();

const normalizeLang = (value) => {
  const safe = String(value || "").toUpperCase();
  return safe === "AR" || safe === "EN" ? safe : null;
};

const getInitialLanguage = () => {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const urlLang = normalizeLang(params.get("lang"));

    if (urlLang) return urlLang;

    const stored = normalizeLang(localStorage.getItem("esill-lang"));
    if (stored) return stored;
  }

  return "EN";
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(getInitialLanguage);

 const setLanguage = useCallback((nextLang) => {
  const normalized = normalizeLang(nextLang);
  if (!normalized) return;

  setLang(normalized);
}, []);

const toggleLanguage = useCallback(() => {
  setLang((prev) => (prev === "EN" ? "AR" : "EN"));
}, []);

  useEffect(() => {
    if (lang === "AR") {
      document.documentElement.dir = "rtl";
      document.documentElement.lang = "ar";
    } else {
      document.documentElement.dir = "ltr";
      document.documentElement.lang = "en";
    }

    if (typeof window !== "undefined") {
      localStorage.setItem("esill-lang", lang);
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}